import React, { useEffect } from 'react';
import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';
import branding from '../../config/branding';

import {
  BaseText,
  Container,
  Subtitle,
  Title,
  TitleSecundary,
  TableContainer,
} from './styles';

const Privacy: React.FC = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, []);

  return (
    <>
      <Header />
      <Container>
        <BaseText>Atualizado em: Agosto de 2026</BaseText>
        <Title>Política de Privacidade</Title>
        <BaseText>
          Prezado usuário, ao fazer o cadastro na nossa plataforma você nos
          confia alguns de seus dados pessoais. Pensando nessa confiança criamos
          a nossa politica de privacidade para que sejam esclarecidas quaisquer
          dúvidas sobre a coleta, o uso e o compartilhamento dos seus dados.
          Essa politica se aplica a todos os sistemas da plataforma TRENZOX,
          seja plataforma web ou aplicativo mobile.
        </BaseText>
        <BaseText>
          Alguns dos dados solicitados são necessários para o cadastro e
          funcionamento da aplicação. Caso não queira fornecer os dados, poderá
          optar por não utilizar a plataforma.
        </BaseText>
        <BaseText>
          Alguns dados solicitados não são obrigatórios e você pode optar por
          não fornece-los sem afetar o uso da plataforma, porém, o não
          fornecimento desses dados podem dificultar o contato entre
          aluno/instituição e vice-versa.
        </BaseText>

        <Subtitle>Como coletamos seus dados</Subtitle>
        <TitleSecundary>Plataforma web</TitleSecundary>
        <BaseText>
          Através da plataforma web coletamos dados referentes ao cadastro da
          instituição e/ou do usuário gestor da instituição, além do cadastro de
          usuários através do convite enviado pelo gestor.
        </BaseText>
        <TitleSecundary>Aplicativo Mobile</TitleSecundary>
        <BaseText>
          Através da aplicação mobile, disponível para android pela loja Google
          Play, coletamos os mesmos dados mencionados acima.
        </BaseText>
        <TitleSecundary>Canais de Atendimento</TitleSecundary>
        <BaseText>
          Podemos coletar informações enviadas por canais de atendimento para
          melhorias na nossa plataforma.
        </BaseText>
        <TitleSecundary>Plataforma de terceiros</TitleSecundary>
        <BaseText>
          plataformas de terceiros, como, Instagram, WhatsApp. Essas plataformas
          possuem as próprias politicas de privacidade. Após a coleta dos dados
          e disponibilização para a plataforma TRENZOX os dados são tratados de
          acordo com a nossa politica. Para mais informações sobre a forma que
          os dados serão tratados por plataformas de terceiros, sugerimos que
          sejam lidas as politicas de privacidades destas plataformas.
        </BaseText>

        <Subtitle>O que coletamos</Subtitle>
        <BaseText>
          Durante seu cadastro e utilização da nossa plataforma, coletamos
          alguns dados pessoais para o funcionamento de todos os serviços
          disponibilizados. Os dados são usados para identificação de usuários,
          comunicação entre instituição e usuários, marketing e funcionamento
          básico da aplicação, como cadastro, login e atribuições de treinos.
          Abaixo é possível ver a descrição dos dados pessoais coletados e como
          serão utilizados.
        </BaseText>
        <TitleSecundary>Dados da instituição</TitleSecundary>
        <BaseText>
          <TableContainer>
            <table>
              <tr>
                <th>Grupo</th>
                <th>Dados</th>
                <th>Finalidade</th>
              </tr>
              <tr>
                <th>Cadastrais</th>
                <td>
                  <ul>
                    <li>Nome;</li>
                    <li>Logo;</li>
                    <li>Telefone;</li>
                    <li>Endereço.</li>
                  </ul>
                </td>
                <td>
                  São dados coletados para cadastramento e identificação da
                  instituição na plataforma. A instituição pode ser exibida na
                  landing page da plataforma, disponível no link{' '}
                  {branding.siteUrl}/, como forma de exibir instituições que
                  usam os nossos serviços. O telefone e endereço são dados
                  opcionais compartilhados com os usuários cadastrado na
                  instituição.
                </td>
              </tr>
            </table>
          </TableContainer>
        </BaseText>

        <TitleSecundary>Dados de usuário</TitleSecundary>
        <BaseText>
          <TableContainer>
            <table>
              <tr>
                <th>Grupo</th>
                <th>Dados</th>
                <th>Finalidade</th>
              </tr>
              <tr>
                <th>Cadastrais</th>
                <td>
                  <ul>
                    <li>Nome completo;</li>
                    <li>Nome de usuário;</li>
                    <li>E-mail;</li>
                    <li>Data de nascimento;</li>
                    <li>Telefone;</li>
                    <li>Foto de perfil (opcional).</li>
                  </ul>
                </td>
                <td>
                  São dados coletados para cadastramento e identificação do
                  usuário na plataforma. O telefone é um dado opcional
                  compartilhado com a instituição que o usuário está cadastrado.
                </td>
              </tr>
              <tr>
                <th>Atendimento</th>
                <td>
                  Coletamos dados de atendimento como elogios, reclamações,
                  sugestões, entre outras mensagens, que podem incluir fotos,
                  vídeos e áudios.
                </td>
                <td>
                  Os dados serão usados como feedback para melhorias na
                  plataforma.
                </td>
              </tr>
            </table>
          </TableContainer>
        </BaseText>

        <BaseText>
          De forma geral, os dados serão utilizados para manutenção da
          aplicação, melhorias nos serviços, desenvolvimento de novas
          funcionalidades, pleno funcionamento da aplicação e marketing, que
          incluem campanhas de divulgação da plataforma e promoções.
        </BaseText>

        <Subtitle>Dados de Crianças e Adolescentes</Subtitle>
        <BaseText>
          A plataforma TRENZOX e aplicativos são destinados a gestores e
          usuários de academias, que por si só já devem ter pelo menos 18 anos.
          Contudo, solicitamos no cadastro a data de nascimento real para
          validação desta informação. Caso seja detectado que o usuário
          cadastrado não tem a idade mínima, o acesso será imediatamente
          bloqueado, e caso seja necessário, excluído.
        </BaseText>

        <Subtitle>Compartilhamento de Dados Pessoais</Subtitle>
        <BaseText>
          Para o funcionamento pleno da plataforma, compartilhamos os dados
          coletados entre aluno e instituição. Além disso, alguns dados
          descritos da seção O que coletamos podem ser usados mara o marketing
          dos nossos serviços. Quando aplicados, seus dados podem ser
          compartilhados com:
        </BaseText>
        <BaseText>
          <ul>
            <li>Gestor/Aluno;</li>
            <li>Usuários que acessarem a landing page;</li>
            <li>
              Provedores de armazenamento de dados e infraestrutura em nuvem;
            </li>
            <li>
              Provedores de pagamento (ex.: Mercado Pago), para processamento de
              cobranças e assinaturas da academia;
            </li>
            <li>
              Provedores de notificação (ex.: Firebase), para envio de
              notificações do aplicativo;
            </li>
            <li>
              Mediante consentimento, de maneiras diferentes das listadas nesta
              política.
            </li>
          </ul>
        </BaseText>

        <Subtitle>Medidas de segurança adotadas</Subtitle>
        <BaseText>
          Diante a confiança dada a nós dos seus dados, estamos comprometidos
          com a segurança das informações fornecidas. A plataforma TRENZOX está
          alinhada com os pilares da segurança da informação, presando a
          Confidencialidade, Integridade e Disponibilidade dos dados pessoais
          dos usuários. Buscamos sempre tornar mais efetivas as medidas de
          segurança, para isso, algumas das nossas medidas para esse feito são:
        </BaseText>
        <BaseText>
          <ul>
            <li>
              Disponibilizar os dados apenas a quem a sua disponibilização é
              imprescindível para o funcionamento da plataforma;
            </li>
            <li>Armazenamento e compartilhamento de forma segura;</li>
            <li>Criptografia de senhas;</li>
          </ul>
        </BaseText>

        <Subtitle>Seus Direitos</Subtitle>
        <BaseText>
          Visamos atender os requisitos de todos os usuários, conforme definido
          pela Lei Geral de proteção de dados, que incluem:
        </BaseText>
        <BaseText>
          <ul>
            <li>Acessar os dados disponibilizados a qualquer momento;</li>
            <li>
              Retificação e alteração dos dados caso estejam incompletos ou
              incorretos;
            </li>
            <li>Exclusão dos dados caso seja de seu desejo;</li>
            <li>
              Informação do uso e atualização da utilização dos dados fornecidos
              a nossa plataforma;
            </li>
            <li>
              Revogação do consentimento, que implica na exclusão do cadastro e
              de todos os dados fornecidos.
            </li>
          </ul>
        </BaseText>

        <Subtitle>Retenção de Dados</Subtitle>
        <BaseText>
          Mantemos seus dados pessoais pelo tempo em que sua conta estiver ativa
          na plataforma, ou pelo tempo necessário para cumprir as finalidades
          descritas nesta política (funcionamento da plataforma, comunicação
          entre aluno e instituição, segurança e cumprimento de obrigações
          legais). Ao excluir sua conta, seus dados pessoais são removidos
          conforme descrito na seção seguinte.
        </BaseText>
        <BaseText>
          Registros financeiros e fiscais vinculados à academia (não à conta
          pessoal de alunos/usuários) podem ser retidos por período adicional,
          independentemente da exclusão de contas de usuários individuais,
          quando exigido pela legislação tributária e contábil aplicável.
        </BaseText>

        <Subtitle>Exclusão de Dados</Subtitle>
        <BaseText>
          Você pode solicitar a exclusão da sua conta e dos dados pessoais
          associados a qualquer momento, diretamente pela plataforma, sem
          precisar entrar em contato com o suporte:
        </BaseText>
        <BaseText>
          <ul>
            <li>
              No aplicativo mobile: acesse Perfil {'>'} Configurações {'>'}{' '}
              Excluir conta;
            </li>
            <li>No painel web: acesse Perfil {'>'} Excluir conta.</li>
          </ul>
        </BaseText>
        <BaseText>
          Após confirmar a exclusão (é necessário digitar uma palavra de
          confirmação, como medida de segurança contra exclusões acidentais),
          sua conta e os dados abaixo são removidos de forma permanente e
          imediata, não podendo ser desfeita:
        </BaseText>
        <BaseText>
          <ul>
            <li>
              dados cadastrais (nome, e-mail, telefone, data de nascimento, foto
              de perfil);
            </li>
            <li>vínculo com a(s) academia(s) em que você está cadastrado;</li>
            <li>histórico de treinos e medidas corporais;</li>
            <li>notificações.</li>
          </ul>
        </BaseText>
        <BaseText>
          Caso prefira, também é possível solicitar a exclusão pelo e-mail{' '}
          <a href={`mailto:${branding.supportEmail}`}>
            {branding.supportEmail}
          </a>
          .
        </BaseText>
        <BaseText>
          Se você for gestor de uma academia, a exclusão da sua conta pessoal
          não remove o cadastro nem os dados financeiros/fiscais da própria
          instituição, já que pertencem à academia, não à sua conta individual —
          para excluir os dados da instituição, entre em contato conosco pelo
          e-mail acima.
        </BaseText>

        <Subtitle>Atualização desta Política de Privacidade</Subtitle>
        <BaseText>
          Ao atualizarmos as nossas politicas de privacidade, elas sempre
          estarão disponíveis nos através do link, para que possam ser revisados
          pelos usuários sempre que necessário.
        </BaseText>
        <BaseText>
          Qualquer dúvida sobre os nossos termos podem ser tratadas através do
          e-mail {branding.supportEmail}. Responderemos com maior brevidade
          possível.
        </BaseText>
      </Container>
      <Footer />
    </>
  );
};

export { Privacy };
